export default "__VITE_ASSET__HSpzauW5__"